import {CookieService} from 'ngx-cookie-service';
import {Injectable} from '@angular/core';
import {AbstractSecurityStorage} from 'angular-auth-oidc-client';
import {environment} from '@env/environment';
import {AuthenticationService} from '@app/core/service/authentication.service';

@Injectable()
export class CookieStorage implements AbstractSecurityStorage {

    constructor(private cookieService: CookieService = new CookieService(document, 'browser')) {
    }

    public read(key: string): any {
        if (this.cookieService.check(key)) {
            let value = this.cookieService.get(key);
            if ((typeof value === 'string') || (<any>value instanceof String)) {
                value = AuthenticationService.tryDecodeURI(value); // ToDo: test without this
            }
            return AuthenticationService.tryParseJSON(value);
        } else {
            return null;
        }
    }

    public readAll(): any {
        const value = this.cookieService.getAll();

        try {
            return AuthenticationService.decodeAndParseObjectValues(value);
        } catch (err) {
            return value;
        }
    }

    public write(key: string, value: any): void {
        value = value || null;
        let valueStr = JSON.stringify(value);
        valueStr = encodeURI(valueStr); // ToDo: test without this
        const domain = this.getDomain(environment.stsServer);
        this.cookieService.set(key, valueStr, undefined, '/', domain, true, 'None'); // ToDo: use Lax?
    }

    public remove(key: string, path?: string, domain?: string, secure?: boolean): void {
        this.cookieService.delete(key, path, domain, secure);
    }

    public clear(path?: string, domain?: string, secure?: boolean, sameSite?: 'Lax' | 'None' | 'Strict'): void {
        this.cookieService.deleteAll(path, domain, secure, sameSite);
    }

    public getDomain(host: string): string {
        const parser = document.createElement('a');
        parser.href = host;
        const hostname = parser.hostname;
        const parts = hostname.split('.');
        const n = parts.length;
        return '.' + [parts[n - 2], parts[n - 1]].join('.');
    }
}
